import $ from 'jquery'

import colors from '../../../../lib/colors'

import { button } from '../../../../component/component'

import save from './save/save'
import remove from './remove/remove'
import cancel from './cancel/cancel'
import label from './label/label'

import change from './change/change'

export default function(o,model,item,done,abort,deleted){

  var fields = model.getFormFields(o,item)

  var p = {
    changes: [],
    errors: [],
    model: model,
    item: item,
    done: done,
    abort: abort,
    deleted: deleted,
  }

  p.label = label(o,p)
  p.cancel = cancel(o,p)
  p.save = save(o,p)
  p.remove = remove(o,p)

  p.change = change(o,p)

  if(!item){
    _.each(fields,function(field){
      if(_.has(field,'init')){
        field.value = field.init
      }
    })
  }

  var headerDiv =
    $('<div>')
    .css({
      position: 'absolute',
      right: 0,
      top: 0,
      left: 0,
      height: '34px',
      overflow: 'hidden',
      borderBottom: '1px solid '+colors.grey.s_800,
    })
    .append([
      p.label,
    ])

  var modelName = model.getName()

  console.log('modelName',modelName)

  if(o.store('role') == 'admin' || o.store('role') == 'author' || modelName == 'userMarker'){
    headerDiv
    .append([
      p.cancel,
      p.save,
      p.remove,
    ])
  }

  var propsDiv =

    $('<div>')
    .css({
      position: 'absolute',
      top: '34px',
      left: 0,
      right: 0,
      bottom: 0,
      overflow: 'scroll',
    })
    .append(
      _.map(
        fields,
        function(field){
          return o.type[field.type].getFormField(o,p,field)
        }
      ),
    )

  p.div =
    $('<div>')
    .css({
      position: 'absolute',
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,
      background: colors.black,
    })
    .append(

      headerDiv,
      propsDiv,

    )

  return p.div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/edit/form/form.js